import { Result } from "appworks/model/gameplay/records/results/result";

export class SlingoReelSpinResult extends Result {
    public resultType: string = "SlingoReelSpinResult";
    public symbols: string[];
    public matches: { matchedValue: number, reelIndex: number }[];
    public patterns: number;
}
